import { render, staticRenderFns } from "./view-nbn-appointment.vue?vue&type=template&id=1fff408e&scoped=true"
import script from "./view-nbn-appointment.vue?vue&type=script&lang=js"
export * from "./view-nbn-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff408e",
  null
  
)

export default component.exports